import { Mail, Phone } from "lucide-react";

export default function Contact() {
  return (
    <div className="min-h-screen bg-background">

      <section className="pt-28 pb-16 bg-surface border-b border-border">
        <div className="max-w-xl mx-auto px-4 sm:px-6 text-center">
          <p className="text-xs font-semibold uppercase tracking-widest text-primary mb-4">Contact</p>
          <h1 className="text-4xl sm:text-5xl font-display font-bold text-foreground leading-tight mb-4">
            Get in Touch
          </h1>
          <p className="text-base text-muted-foreground">
            We'll respond within 24 hours.
          </p>
        </div>
      </section>

      <section className="py-16 bg-background">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-8">
            {/* Email */}
            <div className="flex items-start gap-4 p-6 rounded-xl border border-border bg-card">
              <Mail className="w-6 h-6 text-primary shrink-0 mt-1" />
              <div>
                <h3 className="text-sm font-semibold text-foreground mb-1">Email</h3>
                <a href="mailto:b2b@lingua2.net" className="text-base text-primary hover:underline">
                  b2b@lingua2.net
                </a>
              </div>
            </div>
            {/* Teléfono / WhatsApp */}
            <div className="flex items-start gap-4 p-6 rounded-xl border border-border bg-card">
              <Phone className="w-6 h-6 text-primary shrink-0 mt-1" />
              <div>
                <h3 className="text-sm font-semibold text-foreground mb-1">Phone / WhatsApp</h3>
                <a href="tel:+34622477283" className="text-base text-primary hover:underline">
                  +34 622477283
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}